/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { compact, isEmpty, result } from 'underscore';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { Link } from '@fluentui/react';
import { Tooltip, Button, Text } from '@fluentui/react-components';
import { Warning16Regular } from '@fluentui/react-icons';
import classNames from 'classnames';

import { isLogo, isSmallImage, isLargeImage } from '../../constants/imageTypes';

export const AssetsColumn = ({
  i18n,
  onNavigateToAssetsPage,
  isUnifiedAppAds,
  isMobileAppCampaign,
}) => ({
  key: 'Assets',
  name: i18n.getString(_TL_('Assets')),
  expandProperties: isUnifiedAppAds ? ['Headlines', 'Descriptions', 'Videos', 'Headlines', 'Images'] : ['Headlines', 'Images'],
  className: 'column-assets',
  headerClassName: 'header-assets',
  minWidth: 150,
  maxWidth: 500,
  sortable: false,
  isMultiline: true,
  isResizable: true,
  onRender: (item) => {
    const {
      Id,
      Headlines,
      Images = [],
      LongHeadlines,
      Descriptions,
      Videos,
    } = item;

    const smallImageAssets = Images.filter(image => isSmallImage(result(image, ['Asset', 'SubType'])));
    const largeImageAssets = Images.filter(image => isLargeImage(result(image, ['Asset', 'SubType'])));
    const logoAssets = Images.filter(image => isLogo(result(image, ['Asset', 'SubType'])));
    const imageAssets = Images.filter(image => !isLogo(result(image, ['Asset', 'SubType'])) && !isSmallImage(result(image, ['Asset', 'SubType'])) && !isLargeImage(result(image, ['Asset', 'SubType'])));

    const assetsSummary = compact([
      !isEmpty(largeImageAssets) && i18n.getString(_TL_('Large Images ({{count}})'), { count: `{{bold}}${largeImageAssets.length}{{/bold}}` }),
      !isEmpty(smallImageAssets) && i18n.getString(_TL_('Small Images ({{count}})'), { count: `{{bold}}${smallImageAssets.length}{{/bold}}` }),
      !isEmpty(imageAssets) && i18n.getString(_TL_('Images ({{count}})'), { count: `{{bold}}${imageAssets.length}{{/bold}}` }),
      !isEmpty(logoAssets) && i18n.getString(_TL_('Logo ({{count}})'), { count: `{{bold}}${logoAssets.length}{{/bold}}` }),
      !isEmpty(Headlines) && i18n.getString(_TL_('Short headlines ({{count}})'), { count: `{{bold}}${Headlines.length}{{/bold}}` }),
      !isEmpty(LongHeadlines) && i18n.getString(_TL_('Long headlines ({{count}})'), { count: `{{bold}}${LongHeadlines.length}{{/bold}}` }),
      !isEmpty(Descriptions) && i18n.getString(_TL_('Descriptions ({{count}})'), { count: `{{bold}}${Descriptions.length}{{/bold}}` }),
      !isEmpty(Videos) && i18n.getString(_TL_('Videos ({{count}})'), { count: `{{bold}}${Videos.length}{{/bold}}` }),
    ]).join(i18n.getString(_TL_('; ')));

    const missingVideoDisplayName = i18n.getString(_TL_('Missing videos'));
    const missingVideoTooltip = i18n.getString(_TL_('You don\'t have any video assets, please add them to get better performance.'));

    return (
      <div className="appads-column-assets">
        <div className="assets-summary">
          <ReactTemplate
            model={{
              bold: text => <b>{text}</b>,
            }}
            template={assetsSummary}
          />
        </div>
        {isMobileAppCampaign && isEmpty(Videos) && (
          <Tooltip content={missingVideoTooltip} positioning="after" withArrow>
            <Button className={classNames('assets-status-missing-video-warning')} appearance="subtle" iconPosition="before" icon={<Warning16Regular />}>
              <Text className={classNames('assets-status-missing-video-text')} size={200} weight="regular">
                {missingVideoDisplayName}
              </Text>
            </Button>
          </Tooltip>
        )}
        {isUnifiedAppAds && <Link onClick={() => onNavigateToAssetsPage(Id)}>{i18n.getString(_TL_('View asset details'))}</Link>}
      </div>
    );
  },
});
